<template>
	<div class="body">
		<div class="body-container">
		<!-- 	<div class="title-ctr">
				<el-button type="primary" icon="el-icon-right" size='medium' @click="clickOptimize()"
					class="optimize-btn el-button--warning">结合人社部职业标准优化</el-button>
			</div> -->
			<el-table :data="list" border stripe v-loading="loading" element-loading-text="拼命加载中...">
				<el-table-column label="序号" align="center" prop="index">
				</el-table-column>
				<el-table-column label="岗位名称" align="center" prop="name">
				</el-table-column>
				<el-table-column label="典型工作任务" align="left" prop="content">
					<template v-slot="{ row }">
						<div class="wrap-content">{{formatTextWithLineBreaks(row.task)}}</div>
					</template>
				</el-table-column>
			</el-table>

			<div class="note" v-if="noteData">{{noteData.content}}</div>
		</div>

		<div class="action-ctr" v-if="isDone">
			<el-button type="primary" icon="el-icon-right" size='medium' @click="clickNext()"
				class="next-btn">典型工作任务分析</el-button>
		</div>


		<el-dialog title="选择技能级别" :visible.sync="showLevelDialog" append-to-body v-if="showLevelDialog" align="center"
			width="50%">

			<div class="optimize-note" v-if="note">{{note}}</div>

			<div class="level-ctr">
				<div class="group-row" v-for="(item, key) in levelDataList" :key="key">
					<label>{{item.name}}</label>
					<div class="group-item">
						<el-select v-if=" item.levelMap" class="select-width" placeholder="请选择" @change="changeLevel"
							v-model="selectedLevelMap[key]">
							<el-option v-for="(levelItem, levelKey) in item.levelMap" :key="levelKey"
								:label="levelItem.name" :value="levelKey">
							</el-option>
						</el-select>

						<el-select
							v-if="item.levelMap && item.levelMap[selectedLevelMap[key]] && item.levelMap[selectedLevelMap[key]]['work_code_map']"
							class="select-width code-select" placeholder="请选择" @change="changeCode"
							v-model="selectedCodeMap[key]">
							<el-option
								v-for="(codeItem, codeKey) in item.levelMap[selectedLevelMap[key]]['work_code_map']"
								:key="codeKey" :label="codeKey" :value="codeKey">
							</el-option>
						</el-select>
					</div>


					<el-button type="primary" size="small" class="el-button--warning dialog-standard-btn"
						@click="clickShowStandard(key, item.standard)">{{item.btnName}}</el-button>
				</div>
			</div>

			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" @click="clickOptimizeConfirm()">确定优化</el-button>
				<el-button type="primary" class="el-button--warning" @click="clickCloseLevel()">关闭</el-button>
			</div>
		</el-dialog>


		<el-dialog :title="detailTitle" :visible.sync="showDetailDialog" append-to-body v-if="showDetailDialog"
			align="center" width="70%">

			<el-table :data="standardList" border stripe :span-method="spanMethod">
				<el-table-column label="职业功能" align="center" prop="position">
				</el-table-column>
				<el-table-column label="工作内容" align="center" prop="work">
				</el-table-column>
				<el-table-column label="技能要求" align="left" prop="content">
					<template v-slot="{ row }">
						<div class="wrap-content">{{formatTextWithLineBreaks(row.skill)}}</div>
					</template>
				</el-table-column>

				<el-table-column label="相关知识要求" align="left" prop="content">
					<template v-slot="{ row }">
						<div class="wrap-content">{{formatTextWithLineBreaks(row.knowledge)}}</div>
					</template>
				</el-table-column>
			</el-table>

			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" class="el-button--warning" @click="clickCloseDetail()">关闭</el-button>
			</div>
		</el-dialog>

		<el-dialog :title="detailTitle" :visible.sync="showDefDialog" append-to-body v-if="showDefDialog" align="center"
			width="70%">

			<div class="detail-item">
				<div class="detail-row-title">职业定义</div>
				<div class="detail-row-value">{{defData.content}}</div>
			</div>

			<div class="detail-divider"></div>

			<div class="detail-item">
				<div class="detail-row-title">任务内容</div>
				<div class="detail-row-value">{{defData.task}}</div>
			</div>

			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" class="el-button--warning" @click="clickCloseDef()">关闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		queryJobAttrData,
		getTargetCareerStandardList,
		getCareerLevelStandard,
		calcuJobTypicalTaskByStandard,
		calcuJobCareerAbility,
		getCareerTaskData,
		getTyticalTaskData
	} from "@/api/matrix"

	import aiChatService from '@/utils/aiChat'

	import {
		getSpanMap,
		isEmpty
	} from "@/utils/util"

	import {
		Notification,
		Message,
		Loading
	} from 'element-ui'

	import {
		parse,
		handleProtocal,
		handleRouteProtocal
	} from "@/utils/protocal"

	export default {
		name: "Famous",
		data() {
			return {
				title: '',
				list: [],
				spanMap: {},
				params: {
					page: 1,
					pageSize: 20
				},
				total: 0,
				acceptMap: {},
				careerData: null,
				showLevelDialog: false,
				showDetailDialog: false,
				showDefDialog: false,
				companyName: '',
				jobName: '',
				jobDescription: '',
				levelDataList: [],
				loading: true,
				selectedLevelMap: {},
				selectedCodeMap: {},
				standardList: [],
				detailTitle: '',
				currentEventSource: null,
				noteData: null,
				note: '',
				defData: null,
				hasOptimized: false,
				isDone: false
			}
		},
		created() {
			this.initPageData();
		},

		beforeDestroy() {
			// 清理资源
			if (this.currentEventSource) {
				this.currentEventSource.close();
			}
			// aiChatService.cancelRequest();
		},

		methods: {
			initPageData() {
				this.requestData();
				this.streamData();
			},

			requestData() {
				let that = this;
				this.id = this.$route.query.id;
				this.params['id'] = this.id;
				getTyticalTaskData(this.params).then(res => {
					console.log('groupId', this.groupId)
					let realData = res.data;
					this.hasOptimized = realData.hasOptimized == 1 ? true : false;
				});
			},

			async streamData() {
				this.id = this.$route.query.id;
				this.params['id'] = this.id;
				this.isDone = false;
				try {
					// 使用流式对话
					await aiChatService.customeStream('matrix/streamTypicalTask', this.params, {
						onMessage: (chunk) => {
							// console.log('onMessage chunk', chunk)
							this.list = chunk.data.list;
							this.noteData = chunk.data.noteData;
							
							let hasData = this.loading && ((this.list && this.list.length > 0) || this.noteData);
							// console.log('this.loading hasData', hasData)
							if (hasData){
								this.loading = false;
								console.log('this.loading2222222222', this.loading)
							}
			
							// console.log(111111);
						},

						onComplete: (data) => {
							console.log('对话完成:', data);
							Message({
								message: '已分析完成',
								type: 'success',
								zIndex: 300000
							})
						},

						onError: (error) => {
							this.$message.error('请求失败: ' + error);

						},

						onDone: () => {
							this.isDone = true;
						},
					});

				} catch (error) {
					console.error('对话异常:', error);
				}
			},

			// 方法：格式化文本
			formatTextWithLineBreaks(text) {
				text = text.replaceAll('；', '；\n')
				text = text.replaceAll(';', '；\n')
				return text;
			},

			clickOptimize() {
				this.params['id'] = this.id;
				getTargetCareerStandardList(this.params).then(res => {
					let realData = res.data;

					this.showLevelDialog = true;
					this.levelDataList = realData.list;
					this.note = realData.note;
				});
			},

			changeLevel(value) {
				console.log('value', value, this.selectedLevelMap)
			},

			changeCode(code) {
				console.log('code', code, this.selectedLevelMap, this.selectedCodeMap)
			},

			clickOptimizeConfirm() {
				this.params['id'] = this.id;
	
				let isLevelOk = true;
				let isCodeOk = true;
				Object.entries(this.levelDataList).forEach(([key, item]) => {
					if (item['standard'] == 1) {
						if(!this.selectedLevelMap[key]){
							isLevelOk = false;
							return;
						}
			
						let level = this.selectedLevelMap[key];
						let workCode = this.selectedCodeMap[key];
						let codeMap = this.levelDataList[key]['levelMap'][level]['work_code_map'] ?? null;
						if (codeMap && !workCode) {
							isCodeOk = false;
							return;
						}
					}
				})
				
				if (!isLevelOk) {
					Message({
						message: '请先选择等级',
						type: 'warning',
						zIndex: 300000
					})
					return;
				}
				
				if (!isCodeOk) {
					Message({
						message: '请先选择工种',
						type: 'warning',
						zIndex: 300000
					})
					return;
				}
				
				this.params['levelData'] = JSON.stringify(this.selectedLevelMap);
				this.params['workCodeData'] = JSON.stringify(this.selectedCodeMap);

				calcuJobTypicalTaskByStandard(this.params).then(res => {
					let realData = res.data;
					this.list = []
					this.noteData = null;
					this.showLevelDialog = false;
					this.loading = true;
					this.hasOptimized = true;
					this.streamData();
				})
			},

			clickShowStandard(code, standard) {
				if (standard == 1) {
					let level = this.selectedLevelMap[code]
					let workCode = this.selectedCodeMap[code]

					console.log('level', level, 'workCode', workCode)
					if (!level) {
						Message({
							message: '请先选择等级',
							type: 'warning',
							zIndex: 300000
						})
						return;
					}

					let codeMap = this.levelDataList[code]['levelMap'][level]['work_code_map'] ?? null;
					console.log('codeMap', codeMap, 'workCode', workCode)
					if (codeMap && !workCode) {
						Message({
							message: '请先选择工种',
							type: 'warning'
						})
						return;
					}

					let params = {
						'code': code,
						'work_code': workCode,
						'level': level
					}

					getCareerLevelStandard(params).then(res => {
						let realData = res.data;

						this.detailTitle = realData.title;
						this.standardList = realData.list;
						this.spanMap = getSpanMap(this.standardList, ['position'])
						this.showDetailDialog = true;
					})

					return;
				}
				let params = {
					'code': code,
				}

				getCareerTaskData(params).then(res => {
					let realData = res.data;

					this.defData = realData.data;
					this.detailTitle = realData.title;
					this.showDefDialog = true;
				});
			},

			spanMethod({
				row,
				column,
				rowIndex
			}) {
				const colProp = column.property // 当前列字段名
				if (this.spanMap[colProp]) {
					const rowspan = this.spanMap[colProp][rowIndex]
					return {
						rowspan,
						colspan: rowspan === 0 ? 0 : 1
					}
				}
				return {
					rowspan: 1,
					colspan: 1
				}
			},

			clickCloseDetail() {
				this.standardList = [];
				this.showDetailDialog = false;
			},

			clickCloseLevel() {
				this.levelDataList = [];
				this.showLevelDialog = false;
			},

			clickCloseDef() {
				this.showDefDialog = false;
			},

			clickNext() {
				if (this.hasOptimized) {
					this.doCalcuJobCareerAbility();
				} else {
					this.$confirm('是否要结合人社部职业标准优化?', '温馨提示', {
						confirmButtonText: '需要优化',
						cancelButtonText: '直接生成',
						type: 'warning', // 图标类型：success, warning, info, error,
						distinguishCancelAndClose: true,
					}).then(() => {
						this.clickOptimize();
					}).catch((action) => {	
						console.log('action', action);
						if (action === 'cancel') {
							this.doCalcuJobCareerAbility();
						}
					});
				}
			},

			doCalcuJobCareerAbility() {
				calcuJobCareerAbility(this.params).then(res => {
					let realData = res.data;

					let id = realData['id']
					let path = '/job_ability?id=' + id;
					this.$router.push(path);
				})
			}

		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "typical_task.scss";
</style>